/** jest ignore */

import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Controls, validators, useFormHelpers } from 'shared/helper/form';
import { PASSWORD_MIN_LENGTH } from 'shared/helper/form/validators';
import { T } from 'shared/helper/translate';
import AsyncFormSubmission from './AsyncFormSubmission';
var Form = Controls.Form,
  Password = Controls.Password;
var validPassword = validators.validPassword;
var defaultValues = {
  oneTimeLoginHash: '',
  password: '',
  userIdentity: ''
};
var ResetPasswordForm = function ResetPasswordForm(_ref) {
  var processing = _ref.processing,
    oneTimeLoginHash = _ref.oneTimeLoginHash,
    userIdentity = _ref.userIdentity,
    resetPassword = _ref.resetPassword;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _useFormHelpers = useFormHelpers(methods),
    populateFormData = _useFormHelpers.populateFormData;
  useEffect(function () {
    populateFormData({
      oneTimeLoginHash: oneTimeLoginHash,
      userIdentity: userIdentity
    });
  }, []);
  return /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    className: "login-form clearfix",
    onSubmit: function onSubmit(data) {
      return resetPassword(data).then(function (_ref2) {
        var redirectUri = _ref2.redirectUri;
        return window.location.assign(redirectUri);
      });
    }
  }, /*#__PURE__*/React.createElement(Password, {
    label: "Password",
    messages: {
      validPassword: function validPassword() {
        return /*#__PURE__*/React.createElement(T, {
          source: "password-too-short",
          params: PASSWORD_MIN_LENGTH
        });
      }
    },
    name: "password",
    validators: {
      validPassword: validPassword
    },
    styles: {
      wrapper: 'mb-3'
    }
  }), /*#__PURE__*/React.createElement(AsyncFormSubmission, {
    processing: processing,
    label: "Reset password"
  }));
};
export default ResetPasswordForm;